import Main from "./components/Main/Main";
import styles from "./styles.module.css";

import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme/theme";

export default function Layout() {
  return (
    <ThemeProvider theme={theme}>
      <div className={styles.layout}>
        <Main />
      </div>
    </ThemeProvider>
  );
}
